import React, { Component} from 'react';
import Button from '@mui/material/Button';
import _ from 'lodash';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import "../../../index.css";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/material/styles';
import * as apiDashBoardService from '../../NewProcess/apiRequestService';
import RejectDialog from './RejectDialog';
import SigningDeviceDialog from './SigningDeviceDialog';
import MobileInfoDialog from './MobileInfoDialog';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import PendingIcon from '@mui/icons-material/Pending';
import Moment from 'moment';
import {getApprovalDetail, getSigningServiceRouter} from '../../NewProcess/apiRequestService';
import styles from '../style.js';
import Stepper from '../../ui/Stepper';
import {LoadArkSigner,SignatureElements } from '../../../utils/arkSigner';
import * as Actions from '../../../redux/actions';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';
import {DownloadFile, DownloadZipFile} from '../../../utils/fileOperation';
import {getParameterByGroupCode} from '../../Parameter/apiRequestService';
import {getCookie,setCookie} from '../../../utils/cookieUtil';
import PropTypes from 'prop-types';

class DetailPage extends Component {
 

  constructor(props) {
    super(props);
    this.state = {
      BoxClass:{
        boxShadow: 12
      },
      processInfos:[],
      processDetails:[],
      processSigners:[],
      selectedValue:{},
      cancelReason:"",
      isDisabled:false,
      isCancelDialogOpen:false,
      isSigningDialogOpen:false,
      isMobileSigningDialogOpen:false,
      steps : [
        'Süreç Başlangıcı',
        'Süreç Onayları',
        'Süreç Sonucu',
      ],
      activeStep:1,
      pinCode:"",
      terminal:"",
      certificate:"",
      phoneNumber:"",
      operatorType:"",
      operatorTypesList:[],
      signType:"",
      routingType:"",
      isBlocking: false
    };
  }

  componentDidMount() {
    const {selectedItem}=this.props;

    getApprovalDetail(selectedItem.id)
    .then((response) => {
        this.setState({selectedValue: response.data}, () => {this.fillPageDetails();});
    })
    .catch((exception) => {
      this.props.actions.setNotification("Detay bilgileri getirilemedi daha sonra tekrar deneyin.", 'error');
      console.log('getApprovalDetail exception: ' + JSON.stringify(exception));
    });

    //Operator Tipi
    getParameterByGroupCode('OPERATOR_TYPE')
    .then((response) => {
      this.setState({operatorTypesList : response.data});
    })
    .catch((exception) => {
      this.props.actions.setNotification("Mobil imza operator tip bilgileri getirilemedi.", 'error');
      console.log('getParameterByGroupCode exception: ' + JSON.stringify(exception));
    }); 
    
    getSigningServiceRouter()
      .then((routerResponse) => {
        this.setState({routingType : routerResponse.data.serviceRouterValue});
      })
      .catch((exception) => {
        console.log('getSigningServiceRouter exception: ' + JSON.stringify(exception));
        return null;
      });

    LoadArkSigner();
  }

  fillPageDetails() {  
    const {selectedItem}=this.props;
    const{selectedValue}=this.state;

    let rows = [
      {name:"Süreç Adı",detail:selectedValue.name},
      {name:"Süreç Grubu",detail:!_.isNil(selectedValue.processTypeDetail) && !_.isNil(selectedValue.processTypeDetail.processGroup)?
      selectedValue.processTypeDetail.processGroup.name:''},
      {name:"Süreç Türü",detail:!_.isNil(selectedValue.processTypeDetail)?selectedValue.processTypeDetail.processTypeName:''},
      {name:"İmzalama Sırası",detail:selectedValue.signOrderTitle},
      {name:"Süreç Sonu Eylemi",detail:selectedValue.endOperationActionTitle}
    ]
    this.setState({processInfos:rows});

    let detailRows = [
      {name:"Süreç Bilgilendirme",detail:selectedValue.notificationTypeTitle},
      {name:"Süreç Sonu Bilgilendirme",detail:selectedValue.endProcessNotificationTypeTitle},
      {name:"Süreç Kayıt Tarihi",detail:Moment(selectedValue.createdDate).format('DD/MM/YYYY HH:mm')},
      {name:"Süreç Oluşturan",detail:selectedValue.createdUser},
      {name:"Dosya Adı",detail:selectedValue.approvalFile.fileName}]
    this.setState({processDetails:detailRows});

    if (!_.isNil(selectedValue.internalSigners)) {
      let signerRows = [];
      for (const element of selectedValue.internalSigners) {
        let value=element;
        signerRows.push({
          name:value.userInfo.name,
          detail:value.signType.parameterName,
          recordStatus:value.recordStatus,
          updateDate:value.lastUpdatedDate});
        
        if(value.id==selectedItem.signerId){
          this.setState({signType : value.signType.parameterValue});
        }
      }
      this.setState({processSigners:signerRows});
    }
  }

  handleViewDoc = () => {
    const { selectedValue } = this.state;
    
    Promise.all([
      apiDashBoardService.getApprovalFile(selectedValue.id),
      apiDashBoardService.getAdditionalFile(selectedValue.id),
    ])
      .then(([approvalFileResponse, additionalFileResponse]) => {
        const approvalFile = approvalFileResponse.data;
        const additionalFile = additionalFileResponse.data;
  
        if (!approvalFile) {
          throw new Error("Süreç dokümanı bulunamadı.");
        }
  
        const filesToDownload = [];
  
        filesToDownload.push({
          fileData: approvalFile.fileData,
          fileName: approvalFile.fileName,
          type: "approval",
        });
  
        if (additionalFile)
          filesToDownload.push({
            fileData: additionalFile.fileData,
            fileName: additionalFile.fileName,
            type: "additional",
          });
  
        if (filesToDownload.length === 1) {
          const file = filesToDownload[0];
          DownloadFile(file.fileData, file.fileName);
        } else {
          DownloadZipFile(filesToDownload);
        }
      })
      .catch((exception) => {
        this.props.actions.setNotification("Dosya bilgileri getirilemedi, daha sonra tekrar deneyin.", "error");
        console.log('handleViewDoc exception: ' + JSON.stringify(exception));
      });
  }

  handleSign = () => {
    const {signType}=this.state;
    if(signType=="1"){
      this.setState({isMobileSigningDialogOpen:true,phoneNumber:getCookie('ms-phoneNumber'),operatorType:getCookie('ms-operator')});
    }
    else{
      let terminal=SignatureElements.Terminal;
      let certificate=SignatureElements.Certificate;

      if (_.isEmpty(terminal) || (_.isEmpty(certificate))){
        this.props.actions.setNotification("Sertifka bilgileri getirilemedi bilgisayarınızda geçerli bir token takılı olduğundan emin olun.", 'error');
        return;
      }

      this.setState({isSigningDialogOpen:true,terminal:terminal,certificate:certificate});
    }
  }

  handleCloseSigningDialog(ele) {
    this.setState({ isSigningDialogOpen: false });
  }

  handleApproveSigningDialog(ele) {
    this.setState({isDisabled:true, isSigningDialogOpen: false});

    const { terminal,certificate,selectedValue,pinCode} = this.state;
    const {selectedItem,actions,closeEditPage}=this.props;

    let terminals=terminal.value.split(",");
    let slotId = terminals[0];
    let library = terminals[1];

    let certificates = certificate.value.split(',');
    let certSerialNumber = certificates[0];
    let certBase64 = certificates[1];

    apiDashBoardService.signingInitialize({certificateBase64:certBase64,signatureType:"1",approvalId:selectedValue.id,signerId:selectedItem.signerId})
    .then((response)=>{
      const initializeResponse=response.data;
      let digestToSignBase64 = initializeResponse.digestBase64;

      window.pwsigner.smartCard.signPKCS1Padding1(function (code, json) {
        let signingResponse = JSON.parse(json);
        let cadesSignatureBase64 = signingResponse[0].signature;

        if (code == window.PWSigner.prototype.codes.RESPONSE_SUCCESSFUL) {
          apiDashBoardService.approveInternalSigner({approvalId:selectedValue.id,signerId:selectedItem.signerId,
            Signing:{transactionUUID:initializeResponse.transactionUUID,signatureBase64:cadesSignatureBase64,operationType:initializeResponse.operationType}})
          .then((finilazeResponse) => {
            actions.setNotification("Başarılı bir şekilde imzalandı", 'success');
            closeEditPage();
          })
          .catch((exception) => {
            actions.setNotification("İmzalama sırasında hata oluştu.", 'error');
            console.log('approveInternalSigner exception: ' + JSON.stringify(exception));
            this.setState({isDisabled:false});
          });
        }
        else{
          actions.setNotification("İmzalama sırasında hata oluştu.", 'error');
          this.setState({isDisabled:false});
        }   
      }, {
        library: library,
        slotId: slotId,
        certSerialNumber: certSerialNumber,
        dataBase64: digestToSignBase64,
        pincode: pinCode,
        addSigningTime: false
      });
    })
    .catch((exception) => {
      this.props.actions.setNotification("İmzalama sırasında hata oluştu.", 'error');
      console.log('signingInitialize exception: ' + JSON.stringify(exception));
      this.setState({isDisabled:false});
    });
  }

  handleInitialsSign(ele){
    const {selectedValue,signType} = this.state;
    const {selectedItem,actions,closeEditPage}=this.props;

     apiDashBoardService.approveInternalSigner({approvalId:selectedValue.id,signerId:selectedItem.signerId, Signing:{signType:signType}})
     .then((finilazeResponse) => {
       actions.setNotification("Başarılı bir şekilde imzalandı", 'success');
       closeEditPage();
     })
     .catch((exception) => {
       actions.setNotification("İmzalama sırasında hata oluştu.", 'error');
       console.log('approveInternalSigner exception: ' + JSON.stringify(exception));
       this.setState({isDisabled:false});
     });
  }

  handleCloseMobileDialog(ele) {
    this.setState({ isDisabled:false, isMobileSigningDialogOpen: false, isBlocking: false});
  }

  validateMobileSigningInfo() {
    const { operatorType, phoneNumber } = this.state;
    const { actions } = this.props;

    const normalizedPhone = (phoneNumber || "")
      .toString()
      .replace(/\s/g, "")
      .replaceAll('+', "");

    const isPhoneEmpty =
      !normalizedPhone ||
      normalizedPhone === "undefined" ||
      normalizedPhone === "90";

    const isOperatorEmpty =
      !operatorType || operatorType === "undefined";

    if (isPhoneEmpty && isOperatorEmpty) {
      actions.setNotification(
        "Telefon numarası girilmesi ve operatör seçilmesi zorunludur.",
        "error"
      );
      return false;
    }

    if (isPhoneEmpty) {
      actions.setNotification(
        "Telefon numarası girilmesi zorunludur.",
        "error"
      );
      return false;
    }

    if (!/^90\d{10}$/.test(normalizedPhone)) {
      actions.setNotification(
        "Geçerli bir telefon numarası giriniz.", 
        "error"
      );
      return false;
    }

    if (isOperatorEmpty) {
      actions.setNotification(
        "Operatör seçilmesi zorunludur.",
        "error"
      );
      return false;
    }

    return true;
  }

  handleApproveMobileDialog(ele) {
    if (!this.validateMobileSigningInfo()) {
      return;
    }
    
    this.setState({ isDisabled:true, isMobileSigningDialogOpen: false });

    const { operatorType,phoneNumber,selectedValue} = this.state;
    const {selectedItem,actions,closeEditPage}=this.props;

    //mobil imza için girdiği telefon ve operator bilgisi 1 yıl olarak cookie'ye yazılır
    setCookie('ms-phoneNumber',phoneNumber, { expires: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000) });
    setCookie('ms-operator',operatorType, { expires: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000) });


    apiDashBoardService.signingInitialize({operatorType:operatorType,phoneNumber:phoneNumber,signatureType:"1",approvalId:selectedValue.id,signerId:selectedItem.signerId})
    .then((response)=>{
      const initializeResponse=response.data;

      if (initializeResponse.isSuccess) {
        apiDashBoardService.approveInternalSigner({approvalId:selectedValue.id,signerId:selectedItem.signerId,
          Signing:{transactionUUID:initializeResponse.transactionUUID,operationType:initializeResponse.operationType, signatureBase64:initializeResponse.digestBase64}})
        .then((finilazeResponse) => {
          const isFinalizeSuccess=finilazeResponse.data;
          if (isFinalizeSuccess) {
            actions.setNotification("Başarılı bir şekilde imzalandı", 'success');
            closeEditPage();
          }
          else
            actions.setNotification("İmzalama sırasında operatör kaynaklı hata oluştu. Tekrar deneyiniz.", 'error');
            this.setState({isDisabled:false});
        })
        .catch((exception) => {
          actions.setNotification("Mobil imzalama sırasında hata oluştu.", 'error');
          console.log('approveInternalSigner exception: ' + JSON.stringify(exception));
          this.setState({isDisabled:false});
        });
      }
      else{
        actions.setNotification("İmzalama sırasında operatör kaynaklı hata oluştu. Tekrar deneyiniz.", 'error');
        this.setState({isDisabled:false});
      }
    })
    .catch((exception) => {
      this.props.actions.setNotification("Mobil imzalama sırasında hata oluştu.", 'error');
      console.log('signingInitialize exception: ' + JSON.stringify(exception));
      this.setState({isDisabled:false});
    });
  }

  handleCancel = () => {
    this.setState({isCancelDialogOpen:true});
  }

  handleCloseCancelDialog(ele) {
    this.setState({ isCancelDialogOpen: false });
  }

  handleApproveCancelDialog(ele) {
    this.setState({ isCancelDialogOpen: false });
    const{selectedValue,cancelReason}=this.state;
    const {selectedItem}=this.props;

    if(_.isEmpty(cancelReason)){
      this.props.actions.setNotification('Red açıklaması girilmesi zorunludur.', 'warning');
      return;
    }
    
    apiDashBoardService.cancelInternalSigner({approvalId:selectedValue.id,signerId:selectedItem.signerId,cancelReason:cancelReason})
    .then((response) => {
      this.props.actions.setNotification("Başarılı bir şekilde reddedildi", 'success');
      this.props.closeEditPage();
    })
    .catch((exception) => {
      this.props.actions.setNotification("Reddedilme sırasında hata oluştu.", 'error');
      console.log('handleCancel exception: ' + JSON.stringify(exception));
    });
  }

  handleChange = event => {
    const fieldName = event.target.name;
    const fieldValue = event.target.value;

    this.setState({ [fieldName]: fieldValue });
  }; 

  handleSignDss(ele){
    this.setState({ isDisabled: true, isBlocking: true});
    const {selectedValue,routingType, signType} = this.state;
    const {selectedItem,actions,closeEditPage}=this.props;

    //Mobil imzalama ise dialog açılır.
    if(signType=="1"){
      this.setState({isMobileSigningDialogOpen:true,phoneNumber:getCookie('ms-phoneNumber'),operatorType:getCookie('ms-operator')});
    }
    else{
     apiDashBoardService.sign({approvalId:selectedValue.id,signerId:selectedItem.signerId})
     .then((finalizeResponse) => {
      if(finalizeResponse.statusCode == 200 && finalizeResponse.data == true){
        actions.setNotification("Başarılı bir şekilde imzalandı", 'success');
        closeEditPage();
      }
      else {
        actions.setNotification("İmzalama sırasında hata oluştu.", 'error');
        this.setState({isDisabled:false, isBlocking:false});
      }
     })
     .catch((exception) => {
      actions.setNotification("İmzalama sırasında hata oluştu.", 'error');
      console.log('sign exception: ' + JSON.stringify(exception));
      this.setState({isDisabled:false, isBlocking:false});
     });
    }
  }

  handleApproveMobileDialogDss() {
    if (!this.validateMobileSigningInfo()) {
      return;
    }
    this.setState({ isDisabled: true, isMobileSigningDialogOpen: false, isBlocking: true});

    const { operatorType, phoneNumber, selectedValue } = this.state;
    const { selectedItem, actions, closeEditPage } = this.props;

    //mobil imza için girdiği telefon ve operator bilgisi 1 yıl olarak cookie'ye yazılır
    setCookie('ms-phoneNumber', phoneNumber, { expires: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000) });
    setCookie('ms-operator', operatorType, { expires: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000) });
    apiDashBoardService.sign({ approvalId: selectedValue.id, signerId: selectedItem.signerId, operator: operatorType, phoneNumber: phoneNumber })
      .then((finalizeResponse) => {
        if(finalizeResponse.statusCode == 200 && finalizeResponse.data == true){
          actions.setNotification("Başarılı bir şekilde imzalandı", 'success');
          closeEditPage();
        }
        else {
          actions.setNotification("İmzalama sırasında hata oluştu.", 'error');
          this.setState({ isDisabled: false, isBlocking: false});
        }
      })
      .catch((exception) => {
        actions.setNotification("İmzalama sırasında hata oluştu.", 'error');
        console.log('sign exception: ' + JSON.stringify(exception));
        this.setState({ isDisabled: false, isBlocking: false});
      });
  }

  getUserIcon(recordStatus) {
    switch (recordStatus) {
      case "O":
        return (<TableCell sx={{width:"10%"}}><ThumbUpAltIcon sx={{color: "#57853f",fontSize: 30}}/></TableCell>);
      case "R":
        return (<TableCell sx={{width:"10%"}}><ThumbDownIcon sx={{color: "#ab3c3c",fontSize: 30}}/></TableCell>);
      default:
        return (<TableCell sx={{width:"10%"}}><PendingIcon sx={{color: "#ff8d00",fontSize: 30}}/></TableCell>);
    }
  }

  getUserApproveText(recordStatus,updateDate) {
    switch (recordStatus) {
      case "O":
        return (<TableCell><div style={styles.approveText}>Onaylandı</div><div style={{fontSize: 12}}>{Moment(updateDate).format('DD/MM/YYYY HH:mm')}</div></TableCell>);
      case "R":
        return (<TableCell><div style={styles.rejectText}>Reddedildi</div><div style={{fontSize: 12}}>{Moment(updateDate).format('DD/MM/YYYY HH:mm')}</div></TableCell>);
      default:
        return (<TableCell><div style={styles.pendingText}>Bekliyor</div></TableCell>);
    }
  }

  render() {
    const { BoxClass,processInfos,processDetails,processSigners,steps,activeStep,isDisabled, signType, routingType} = this.state;
    const {selectedItem}=this.props;

      const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
          backgroundColor: theme.palette.action.hover,
        },
      }));

    return (
      <div>
        <Box sx={{ width: '100%' }}>
          {this.state.isBlocking && (
            <Box
              sx={(theme) => ({
                position: 'fixed',
                inset: 0,
                zIndex: theme.zIndex.modal - 1,
                backgroundColor: 'rgba(255,255,255,0.55)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                pointerEvents: 'all',
              })}
            >
            </Box>
          )}
        <Stepper steps={steps} activeStep={activeStep} stepType={'active'}/>
        
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>

          <Grid item xs={12}>
            <Box sx={BoxClass} className="noShadow">        
              <div className="headerStyle"><h4>Süreç İçeriği</h4></div>
              <div className="component" >
                <Table aria-label="simple table">
                  <TableBody>
                    {processInfos.map((row) => (
                      <StyledTableRow>
                        <TableCell component="th" scope="row" sx={styles.cellName}>               
                          <strong>{row.name}</strong> 
                        </TableCell>
                        <TableCell sx={styles.cellDetail}>{row.detail}</TableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>                  
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Box sx={BoxClass} className="noShadow row"> 
                <div className='col'></div>
                  <div className='sameLine col-auto'>
                    <Button onClick={this.handleViewDoc} style={styles.button} sx={{backgroundColor: '#94B2FF'}} variant="contained" >
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="16" viewBox="0 0 20 24" fill="none"><path d="M16.3624 8.47059H14.1176V1.41176C14.1176 0.635294 13.4824 0 12.7059 0H7.05882C6.28235 0 5.64706 0.635294 5.64706 1.41176V8.47059H3.40235C2.14588 8.47059 1.51059 9.99529 2.4 10.8847L8.88 17.3647C9.43059 17.9153 10.32 17.9153 10.8706 17.3647L17.3506 10.8847C18.24 9.99529 17.6188 8.47059 16.3624 8.47059ZM0 22.5882C0 23.3647 0.635294 24 1.41176 24H18.3529C19.1294 24 19.7647 23.3647 19.7647 22.5882C19.7647 21.8118 19.1294 21.1765 18.3529 21.1765H1.41176C0.635294 21.1765 0 21.8118 0 22.5882Z" fill="#ffffff"/></svg>
                    <span className='d-block' style={{marginLeft: '8px'}}>Dosya İndir</span>
                    </Button>
                  </div>
                <div className='sameLine col-auto'>
                  <Button onClick={this.handleCancel} style={styles.button} sx={{backgroundColor: '#FF5977;'}} variant="contained" >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 12 12" fill="none"><g clip-path="url(#clip0_126_2364)"><path d="M11.6175 11.6175C11.1075 12.1275 10.2825 12.1275 9.7725 11.6175L6 7.845L2.2275 11.6175C1.7175 12.1275 0.8925 12.1275 0.3825 11.6175C-0.1275 11.1075 -0.1275 10.2825 0.3825 9.7725L4.155 6L0.3825 2.2275C-0.1275 1.7175 -0.1275 0.8925 0.3825 0.3825C0.8925 -0.1275 1.7175 -0.1275 2.2275 0.3825L6 4.155L9.7725 0.3825C10.2825 -0.1275 11.1075 -0.1275 11.6175 0.3825C12.1275 0.8925 12.1275 1.7175 11.6175 2.2275L7.845 6L11.6175 9.7725C12.1125 10.2675 12.1125 11.1075 11.6175 11.6175Z" fill="#fff"/></g><defs><clipPath id="clip0_126_2364"><rect width="12" height="12" fill="white"/></clipPath></defs></svg> 
                  <span className='d-block' style={{marginLeft: '8px'}}>Reddet</span>
                  </Button>
                </div>
                <div className='sameLine col-auto'>
                <Button
                    onClick={() => {
                      if (signType === '3') this.handleInitialsSign(); else if (routingType == "DigitalSignService") this.handleSignDss(); else this.handleSign();}} 
                      style={styles.button} sx={{ backgroundColor: '#00E994' }} variant="contained" disabled={isDisabled} >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="17" viewBox="0 0 24 17" fill="none"><g clip-path="url(#clip0_126_2287)"><path d="M21.04 16.99C19.33 16.99 16.69 16.69 14.83 15.09C14.42 14.74 14.08 14.34 13.79 13.9C13.62 14.16 13.44 14.44 13.25 14.73C12.19 16.35 10.48 16.94 8.57001 16.38C7.51001 16.06 6.46001 15.41 5.50001 14.54C4.55001 15.25 3.47001 15.97 2.26001 16.7C1.55001 17.13 0.630007 16.9 0.200007 16.19C-0.229993 15.48 7.09295e-06 14.56 0.710007 14.13C1.76001 13.5 2.70001 12.88 3.53001 12.27C2.29001 10.45 1.48001 8.32 1.48001 6.42C1.50001 2.63 4.09001 0 6.42001 0C7.18001 0 10.98 0.31 10.98 6.38C10.98 8.44 9.94001 10.49 7.83001 12.56C8.38001 13.01 8.93001 13.34 9.44001 13.49C10.16 13.7 10.47 13.49 10.75 13.07C11.78 11.5 12.47 10.36 12.91 9.48C13.22 8.86 13.92 8.53 14.6 8.69C15.28 8.85 15.76 9.45 15.76 10.15C15.76 11.33 16.1 12.2 16.8 12.81C18.32 14.13 21.28 14.06 22.3 13.91C23.12 13.81 23.88 14.37 23.99 15.18C24.11 16 23.54 16.76 22.72 16.87C22.65 16.88 21.99 16.97 21.05 16.97L21.04 16.99ZM6.42001 3C5.93001 3 4.51001 4.17 4.51001 6.4C4.51001 7.66 5.06001 9.06 5.86001 10.3C7.26001 8.89 7.99001 7.57 7.99001 6.38C7.99001 5.36 7.84001 3 6.43001 3H6.42001Z" fill="#fff"/></g><defs><clipPath id="clip0_126_2287"><rect width="24" height="16.99" fill="white"/></clipPath></defs></svg> 
                  <span className='d-block' style={{marginLeft: '8px'}}>İmzala ({selectedItem.signType})</span>
                  </Button>
                </div>  
                <div className='col'></div>                             
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Box sx={BoxClass} className="noShadow">        
              <div className="headerStyle"><h4>Süreç İmzacıları</h4></div>
              <div className="component" >
                <Table aria-label="simple table">
                  <TableBody>
                    {processSigners.map((row) => (
                      <StyledTableRow>
                        {this.getUserIcon(row.recordStatus)}
                        <TableCell component="th" scope="row" sx={styles.cellName}>               
                          <strong>{row.name}</strong> 
                        </TableCell>
                        <TableCell sx={styles.cellDetail}>{row.detail}</TableCell>
                        {this.getUserApproveText(row.recordStatus,row.updateDate)}
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>                  
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Box sx={BoxClass} className="noShadow">        
              <div className="headerStyle"><h4>Süreç Ayrıntıları</h4></div>
              <div className="component" >
                <Table aria-label="simple table">
                  <TableBody>
                    {processDetails.map((row) => (
                      <StyledTableRow>
                        <TableCell component="th" scope="row" sx={styles.cellName}>               
                          <strong>{row.name}</strong> 
                        </TableCell>
                        <TableCell sx={styles.cellDetail}>{row.detail}</TableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>                  
            </Box>
          </Grid>

        </Grid>
        </Box>
        <div>
        <RejectDialog open = {this.state.isCancelDialogOpen} handleChange = {(e) => this.handleChange(e)} 
            onClose = {(e) => this.handleCloseCancelDialog(e)} handleApprove = {(e) => this.handleApproveCancelDialog(e)}/>
        </div>
        <div>
        <SigningDeviceDialog open = {this.state.isSigningDialogOpen} {...this.state} handleChange = {(e) => this.handleChange(e)} 
            onClose = {(e) => this.handleCloseSigningDialog(e)} handleApprove = {(e) => this.handleApproveSigningDialog(e)}/>
        </div>
        <div>
        <MobileInfoDialog open = {this.state.isMobileSigningDialogOpen} {...this.state} handleChange = {(e) => this.handleChange(e)} 
            onClose = {(e) => this.handleCloseMobileDialog(e)} handleApprove = {(e) => {if (routingType == "DigitalSignService") this.handleApproveMobileDialogDss(); else this.handleApproveMobileDialog(e)}}/>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(Actions, dispatch)
});

DetailPage.propTypes = {
  actions: PropTypes.shape({
    setNotification: PropTypes.func
  })
};

export default compose(
  connect(
    null,
    mapDispatchToProps
  ),
)(DetailPage);